"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasBeenProcessed = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("../../components");
var ButtomComponent_1 = __importDefault(require("../../components/Form/ButtomComponent"));
var constants_1 = require("../../constants");
var containers_1 = require("../../containers");
var context_1 = require("../../context");
var hooks_1 = require("../../hooks");
var useFetchCampaignsByMerchant_1 = __importDefault(require("../../hooks/fetch/campaigns/useFetchCampaignsByMerchant"));
var useDisclosure_1 = __importDefault(require("../../hooks/useDisclosure"));
var models_1 = require("../../models");
var styles_1 = require("../../styles");
var utilities_1 = require("../../utilities");
exports.hasBeenProcessed = [
    models_1.EnumCampaignStatus.PENDING_SEND_EMAIL,
    models_1.EnumCampaignStatus.SENT_EMAIL_ACTIVATION,
];
var CampaignList = function () {
    var _a, _b;
    var _c = (0, react_router_dom_1.useSearchParams)(), searchParams = _c[0], setSearchParams = _c[1];
    var disclosureCampaignDrawer = (0, useDisclosure_1.default)();
    var headerContainer = (0, react_1.useRef)(null);
    var termSearch = searchParams.get('term');
    var _d = (0, useFetchCampaignsByMerchant_1.default)(), campaignsData = _d.data, isLoading = _d.isLoading, isFetching = _d.isFetching, refetch = _d.refetch;
    var _e = (0, hooks_1.useGlobalState)(constants_1.GET_DETAIL_CAMPAIGN), setCampaignDetail = _e[1];
    var handleShowDetail = function (item) {
        searchParams.set('campaignIdentifier', item.id);
        setSearchParams(searchParams);
        disclosureCampaignDrawer.onOpen();
        setCampaignDetail(item);
    };
    var handleCloseCampaignDrawer = function () {
        searchParams.delete('campaignIdentifier');
        setSearchParams(searchParams);
        disclosureCampaignDrawer.onClose();
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.WrapperPage, { children: [(0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ elevation: 0, sx: { marginBottom: '30px' }, ref: headerContainer }, { children: [(0, jsx_runtime_1.jsx)(components_1.SectionTitle, { title: "Campa\u00F1as", renderRight: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "Refrescar lista" }, { children: (0, jsx_runtime_1.jsx)(ButtomComponent_1.default.Filter, __assign({ variant: "outlined", color: "inherit", onClick: function () { return refetch(); } }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Refresh, {}) })) })) }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                            display: 'grid',
                            gap: '5px',
                            gridTemplateColumns: '1fr',
                        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ style: {
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '10px',
                                } }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                                        width: { xs: '100%', sm: '30%' },
                                    } }, { children: (0, jsx_runtime_1.jsx)(components_1.InputSearch, { placeholder: "Buscar campa\u00F1a" }) })) })), (0, jsx_runtime_1.jsx)(styles_1.HelperText, { children: "Buscar por: Descripci\u00F3n, Cantidad de Tarjetas, Monto." })] })), (0, jsx_runtime_1.jsx)(containers_1.HelperSearchOrFilterContainer, { search: termSearch !== null && termSearch !== void 0 ? termSearch : '' })] })), (0, jsx_runtime_1.jsx)(material_1.Paper, { children: (0, jsx_runtime_1.jsx)(components_1.TableComponent, { variant: "normal", isLoading: isLoading || isFetching, rows: (_a = campaignsData === null || campaignsData === void 0 ? void 0 : campaignsData.filter(function (c) {
                        return ['description', 'cards_quantity', 'cards_amount'].some(function (key) {
                            var _a;
                            return String(c[key])
                                .toLowerCase()
                                .includes((_a = termSearch === null || termSearch === void 0 ? void 0 : termSearch.toLocaleLowerCase()) !== null && _a !== void 0 ? _a : '');
                        });
                    })) !== null && _a !== void 0 ? _a : [], keyExtractor: function (item) { return item.id; }, stickyHeader: true, maxHeight: "calc(100vh - ".concat(headerContainer.current &&
                        ((_b = headerContainer.current) === null || _b === void 0 ? void 0 : _b.clientHeight) + 240, "px)"), columns: [
                        {
                            label: 'Descripción',
                            field: 'description',
                            type: 'text',
                            valueGetter: function (_a) {
                                var row = _a.row;
                                return row.description;
                            },
                        },
                        {
                            label: 'Cantidad de Tarjetas',
                            field: 'cards_quantity',
                            align: 'right',
                            type: 'text',
                            valueGetter: function (_a) {
                                var row = _a.row;
                                return row.cards_quantity;
                            },
                        },
                        {
                            label: 'Monto a Recargar',
                            field: 'cards_amount',
                            align: 'right',
                            type: 'text',
                            valueGetter: function (_a) {
                                var row = _a.row;
                                return (0, utilities_1.amountFormatByCurrencyCode)({
                                    amount: Number(row.cards_amount),
                                    currency_code: row.cards_currency_code,
                                });
                            },
                        },
                        {
                            label: 'Tarjetas Usadas',
                            field: 'cards_used',
                            align: 'right',
                            type: 'text',
                            valueGetter: function (_a) {
                                var row = _a.row;
                                return row.cards_used;
                            },
                        },
                        {
                            label: 'Estado',
                            field: 'status',
                            align: 'center',
                            type: 'text',
                            valueGetter: function (_a) {
                                var row = _a.row;
                                return exports.hasBeenProcessed.some(function (status_processed) { return row.status === status_processed; }) ? ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { color: context_1.theme.palette.success.light } }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.CheckCircle, {}) }))) : ((0, jsx_runtime_1.jsx)(containers_1.ChipStatusContainer, { status: 'IN_PROCESS' }));
                            },
                        },
                        {
                            label: 'Fecha de Registro',
                            field: 'created_at',
                            align: 'left',
                            type: 'text',
                            valueGetter: function (_a) {
                                var row = _a.row;
                                return (0, utilities_1.formatDate)({ date: row.created_at });
                            },
                        },
                        {
                            label: 'Opciones',
                            align: 'right',
                            field: 'actions',
                            type: 'text',
                            valueGetter: function (_a) {
                                var row = _a.row;
                                return ((0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: "row", justifyContent: "flex-end", spacing: 1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "Ver detalles" }, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ color: "default", onClick: function () { return handleShowDetail(row); } }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Visibility, {}) })) })) })));
                            },
                        },
                    ] }) }), (0, jsx_runtime_1.jsx)(containers_1.DrawerCampaignMerchantDetailContainer, { open: disclosureCampaignDrawer.isOpen, onClose: handleCloseCampaignDrawer, onOpen: disclosureCampaignDrawer.onOpen })] }));
};
exports.default = CampaignList;
